<form class="searchbar">
  <i class="icon far fa-search"></i>
  <input class="search" type="text" [placeholder]="'SEARCH' | translate" [formControl]="searchControl" />
</form>
